var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    className: "icon",
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38471 9.09091H13.0772V0.909091C13.0772 0.667985 12.9961 0.436754 12.8519 0.266267C12.7076 0.0957791 12.5119 0 12.3079 0H0.769244C0.565228 0 0.369568 0.0957791 0.225306 0.266267C0.0810451 0.436754 0 0.667985 0 0.909091V19.0909C0 19.332 0.0810451 19.5632 0.225306 19.7337C0.369568 19.9042 0.565228 20 0.769244 20H12.3079C12.5119 20 12.7076 19.9042 12.8519 19.7337C12.9961 19.5632 13.0772 19.332 13.0772 19.0909V10.9091H5.38471V9.09091Z",
    fill: "#97A7B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7749 9.3574L15.3849 4.16876L14.2969 5.45456L17.3739 9.09092H13.0771V10.9091H17.3739L14.2969 14.5455L15.3849 15.8313L19.7749 10.6426C19.919 10.4722 20 10.241 20 10C20 9.75901 19.919 9.52787 19.7749 9.3574V9.3574Z",
    fill: "#97A7B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.2c0ae6ca.svg";
export { ForwardRef as ReactComponent };